export default __webpack_public_path__ + "bddd94e.png";